import { useState } from 'react';
import { useRecoilValue } from 'recoil';

import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import TranslationText from '@Components/Utilities/TranslationText';
import EmptyLegAlertModal from '@Components/Shared/Modals/EmptyLegAlertModal';
import atoms from '@Components/Utilities/SandhillsAtoms';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';


const EmptyLegAlertsListView = (props) => {

    const routes = useRecoilValue(atoms.routes);

    const [emptyLegAlerts, setEmptyLegAlerts] = useState(props.EmptyLegAlerts ? props.EmptyLegAlerts : []);
    const [showAlertModal, setShowAlertModal] = useState(false);
    const currentUser = useRecoilValue(atoms.currentUser);
    const currentSite = useRecoilValue(atoms.currentWebsite);

    const deleteAlert = (id) => {
        if (confirm('Are you sure you want to delete this alert?')) {
            sandhillsRequest({
                url: routes.EmptyLegAlertDelete.replace("{0}", id),
                method: 'post',
                errorHandling: {
                    useConsole: false,
                    useAlert: false
                }
            }).then(() => {
                setEmptyLegAlerts((previousState) => {
                    return previousState.filter(alert => alert.EmptyLegAlertID !== id);
                });
            });
        }
    };

    const handleAlertSaved = (newAlert) => {
        setEmptyLegAlerts((previousState) => {
            const index = previousState.findIndex(a => a.EmptyLegAlertID === newAlert.EmptyLegAlertID);
            if (index >= 0) {
                previousState[index] = newAlert;
                return [...previousState];
            } else {
                return [...previousState, newAlert];
            }
        });
    };

	return (
        <div className='wtb-splash'>
            <div className='main'>
                <div className='container'>
                    <div className='breadcrumbs'>
                        <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={"Empty Legs Alerts"} />
                    </div>
                    <div className='wrapper'>
                        <div className='flex-col'>
                            <h1>Let Us Inform You When Empty Leg Flights Are Available</h1>
                            <p>Can't find the empty leg you're looking for? Forget checking back repeatedly to search for the same flight. Simply enter your search criteria once and let CharterHub's Empty Leg Alerts feature do the work. It's free to use. The feature is free for registered users.</p>
                            <p className="primary"><strong>Ready to find your next empty leg? Submit a request, and we'll keep you posted!</strong></p>
                            {currentUser?.IsAuthenticated ?
                                <button className='block-btn' onClick={() => setShowAlertModal(true)}>
                                    <i className="fa-solid fa-bell"></i>Set Up Alerts
                                </button>

                                :
                                <a className='block-btn' href={"/sso/login"} target='_self'>{translator.translate('sandhills.tradesites.mvc.signintogetstarted')}</a>
                            }
                        </div>
                        <div className='flex-col'>
                            <img src='/Content/images/empty-leg-alerts.jpg' alt={translator.translate('sandhills.tradesites.mvc.wanttobuyimagealttext')}></img>
                        </div>
                    </div>
                </div>
            </div>
            <div className='main grey-section'>
                <div className='container'>
                    <div className='flex-row'>
                        <div className='flex-col'>
                            <h2>How Empty Leg Alerts Work</h2>
                            <div className='icon-row block'>
                                <ul>
                                    <li>
                                        <i className="fa-regular fa-paper-plane"></i>
                                        <p><strong>{"1.  Submit Your Empty Leg Alert Request"}</strong> Add destination cities and/or routes of interest.</p>
                                    </li>
                                    <li>
                                        <i className="fa-regular fa-envelope"></i>
                                        <p><strong>{"2. " + translator.translate('sandhills.tradesites.mvc.keepaneyeout')}</strong> If a matching empty leg is posted, you'll get an instant email with the operator's contact info.</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className='flex-col'>
                            <h2>Why Use Empty Leg Alerts?</h2>
                            <div className='icon-row block'>
                                <ul>
                                    <li>
                                        <i className="fa-regular fa-bell"></i>
                                        <p><strong>Get The Flights You Need</strong> When we find a matching flight, you get notified. It's as simple as that.</p>
                                    </li>
                                    <li>
                                        <i className="fa-regular fa-clock"></i>
                                        <p><strong>Save Time & Effort</strong> Why search for empty legs repeatedly when you can search once and let us find your match? Plus, you can enter multiple searches to get more results.</p>
                                    </li>
                                    <li>
                                        <i className="fa-regular fa-money-bill-1"></i>
                                        <p><strong>It’s Free</strong> There's no cost and no hassle. It's the smart way to find your next empty leg.</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='wtb-banner'>
                <h2><strong>Ready To Find Your Empty Leg?</strong> Register, submit your request, and we'll let you know when there's a match!</h2>
                {currentUser?.IsAuthenticated ?
                    <button className='block-btn' onClick={() => setShowAlertModal(true)}>
                        <i className="fa-solid fa-bell"></i>Set Up Alerts
                    </button>
                    
                    :
                    <a className='block-btn' href={"/sso/login"} target='_self'>{translator.translate('sandhills.tradesites.mvc.signintogetstarted')}</a>
                }
            </div>
            {showAlertModal &&
                <EmptyLegAlertModal
                    onClose={() => setShowAlertModal(false)}
                    onSave={handleAlertSaved}
                />
            }
        </div>
	);
};

export default EmptyLegAlertsListView;
